import { AfterViewInit, Component, Input } from '@angular/core';
import { SnackService } from '../../../service/snack.service';
import { UserdataService } from '../../../service/userdata.service';
import { UploadService } from '../../../service/upload.service';

@Component({
  selector: 'app-rag-component',
  standalone: false,
  templateUrl: './rag-component.component.html',
  styleUrl: './rag-component.component.scss'
})
export class RagComponentComponent implements AfterViewInit {

  @Input() hubId: string = '';
  @Input() label: string = 'Files';
  files: any = [];

  constructor(
    private snack: SnackService,
    private user: UserdataService,
    private uploadService: UploadService
  ) {

  }


  ngAfterViewInit(): void {
    this.loadData();
  }

  allowedTypes = [,
    "text/plain",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ];

  async loadData() {
    this.files = await this.uploadService.getHubFilesByHubId(this.hubId);
  }

  async deleteFile(file: any) {
    if (file.error) {
      this.files = this.files.filter((f: any) => f.fileId !== file.fileId);
      return;
    }
    let result = await this.uploadService.deleteFile(file.fileId);
    if (result == true) {
      this.files = this.files.filter((f: any) => f.fileId !== file.fileId);
    }
  }
  async uploadFiles(files: any) {
    for await (const file of files) {

      // ToDo: check if filename exists in files
      if (this.files.find((f: any) => f.name === file.name)) {
        file.error = true;
        file.errorText = "File already exists";
      }

      if (!this.allowedTypes.includes(file.type)) {
        file.error = true
        file.errorText = "Filetype not allowed";
      }

      if (file.size > 2000000) {
        file.error = true;
        file.errorText = "File is too big max 2MB";
      }

      this.files.unshift(file)
    }


    console.log('Fiels', files);

    for (let i = 0; i < files.length; i++) {
      if (files[i].error) { continue; }
      files[i].fileType = 'SYSTEM';

      this.uploadService.uploadFile(files[i], this.hubId, 'SYSTEM').subscribe((percentage) => {
        for (let j = 0; j < this.files.length; j++) {
          if (this.files[j].name === files[i].name) {
            this.files[j].percentage = percentage;
          }
        }
      });

    }
  }



  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.uploadFiles(event.dataTransfer?.files);
  }
  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (!inputElement.files || inputElement.files.length === 0) {
      return;
    }
    this.uploadFiles(Array.from(inputElement.files));
  }
}
